export enum HeroVerticalContentPlacement {
  Top = 'flex-start',
  Center = 'center',
  Bottom = 'flex-end'
}
